import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import api from './modules/api'
import user from './modules/user'
import app from './modules/app'
import permission from './modules/permission'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    cancelTokenArr: [], // 取消请求token数组
  },
  mutations: {
    pushToken (state, payload) {
      state.cancelTokenArr.push(payload.cancelToken)
    },
    clearToken ({ cancelTokenArr }) {
      cancelTokenArr.forEach(item => {
        item('路由跳转取消请求')
      })
      cancelTokenArr = []
    }
  },
  modules: {
    user,
    app,
    api,
    permission
  },
  getters
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js